module.exports = __webpack_public_path__ + "static/media/sasha_hs.d60f7f75.webp";